import api from '../libs/axios';

export const getEvaluationList = async (params, signal) => {
  const response = await api.get('/evaluation', { params, signal });
  return response.data;
};

export const sendEvaluation = async (dto, signal) => {
  const response = await api.post('/evaluation', dto, { signal });
  return response.data;
};
